"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceivedPackages = void 0;
/* Package Imports */
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = __importDefault(require("lodash"));
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var react_device_detect_1 = require("react-device-detect");
var react_redux_1 = require("react-redux");
var react_toastify_1 = require("react-toastify");
/* Imported CSS */
require("@app/styles/PackageLists.scss");
/* Blast Imports */
var actions_1 = require("../state/actions");
var selectors_1 = require("../state/selectors");
var models_1 = require("@app/_state/models");
var LoadingIndicator_1 = require("@app/components/LoadingIndicator");
var InfoIcon_1 = require("@app/components/controls/InfoIcon");
var DownloadButton_1 = require("@app/components/packages/DownloadButton");
var OpenDownloadButton_1 = require("@app/components/packages/OpenDownloadButton");
var PackageExpiration_1 = require("@app/components/packages/PackageExpiration");
var PackageFileSize_1 = require("@app/components/packages/PackageFileSize");
var PackageProgressBar_1 = require("@app/components/packages/PackageProgressBar");
var PackageProgressDetails_1 = require("@app/components/packages/PackageProgressDetails");
var PauseButton_1 = require("@app/components/packages/PauseButton");
var RetryButton_1 = require("@app/components/packages/RetryButton");
var actions_2 = require("@app/features/package-details/state/actions");
var SortHeader_1 = require("@app/features/package-history/components/SortHeader");
var actions_3 = require("@app/features/transfers/state/actions");
var models_2 = require("@app/features/transfers/state/models");
var selectors_2 = require("@app/features/transfers/state/selectors");
var constants_1 = require("@app/shared/constants");
var matomo_1 = require("@app/shared/matomo");
var log_1 = __importDefault(require("@app/shared/log"));
var utils_1 = require("@app/shared/utils");
var constants_2 = require("@server/shared/constants");
var api_1 = require("@server/types/api");
/**
 * Blast's Received Packages component, displays all the non-new packages in a user's inbox
 * The status of "non-new" meaning the package has expired, has been archived or the user has taken an action against the package
 */
var ReceivedPackages = /** @class */ (function (_super) {
    __extends(ReceivedPackages, _super);
    function ReceivedPackages() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /* Component Lifecycle Methods - End */
        /* Component Methods - Begin */
        _this.handleDownload = function (pkg) {
            if (_this.props.asperaEnabled) {
                _this.props.onConnectDownload(pkg.id);
            }
            else {
                if (_this.props.httpGatewayStatus) {
                    log_1.default.debug("DOWNLOADING USING GATEWAY");
                    var activeGatewayDownloads = _this.props.activeTransfersList.filter(function (t) { return t.type === models_2.TransferType.GATEWAY && t.direction === api_1.Direction.RECEIVE; });
                    if (activeGatewayDownloads.length < constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT) {
                        _this.props.onHttpGatewayDownload(pkg);
                    }
                    else {
                        react_toastify_1.toast.warning(lodash_1.default.capitalize(utils_1.numToWords(constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT)) + " downloads are already in progress.\nPlease enable Aspera to download more than " + utils_1.numToWords(constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT) + " packages at a time.", {
                            autoClose: 10000,
                            toastId: constants_1.GATEWAY_DOWNLOAD_LIMIT_WARNING
                        });
                    }
                }
                else {
                    log_1.default.debug("DOWNLOADING USING PLUGINLESS");
                    _this.props.onHttpDownload(pkg);
                }
            }
            new matomo_1.MatomoTracker().trackEvent('Received Packages', 'Download Package', pkg.id);
        };
        _this.handleDownloadRetry = function (pkg) {
            if (_this.props.asperaEnabled) {
                if (pkg.packageTransferId) {
                    _this.props.onResumeConnectTransfer(pkg.packageTransferId);
                }
                else {
                    _this.props.onConnectDownload(pkg.id);
                }
            }
            else {
                if (_this.props.httpGatewayStatus) {
                    log_1.default.debug("RETRYING DOWNLOAD USING GATEWAY");
                    var activeGatewayDownloads = _this.props.activeTransfersList.filter(function (t) { return t.type === models_2.TransferType.GATEWAY && t.direction === api_1.Direction.RECEIVE; });
                    if (activeGatewayDownloads.length < constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT) {
                        _this.props.onHttpGatewayDownload(pkg);
                    }
                    else {
                        react_toastify_1.toast.warning(lodash_1.default.capitalize(utils_1.numToWords(constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT)) + " downloads are already in progress.\nPlease enable Aspera to download more than " + utils_1.numToWords(constants_1.ACTIVE_GATEWAY_DOWNLOAD_LIMIT) + " packages at a time.", {
                            autoClose: 10000,
                            toastId: constants_1.GATEWAY_DOWNLOAD_LIMIT_WARNING
                        });
                    }
                }
                else {
                    log_1.default.debug("RETRYING DOWNLOAD USING PLUGINLESS");
                    _this.props.onHttpDownload(pkg);
                }
            }
            var retryEventLog = (_this.props.asperaEnabled) ? 'Resume Download Package' : 'Retry Download Package';
            new matomo_1.MatomoTracker().trackEvent('Received Packages', retryEventLog, pkg.id);
        };
        _this.handleDownloadStop = function (pkg) {
            if (pkg.packageTransferId) {
                _this.props.onStopConnectTransfer(pkg.packageTransferId);
                new matomo_1.MatomoTracker().trackEvent('Received Packages', 'Stop Download Package', pkg.id);
            }
            else {
                log_1.default.debug("Unable to stop transfer of '" + pkg.title + "' (" + pkg.id + ")");
            }
        };
        _this.handleLoadMore = function () {
            _this.props.onLoadMore(_this.props.pageSize, _this.props.searchTerm);
            new matomo_1.MatomoTracker().trackEvent('Received Packages', 'Load More');
        };
        _this.handleOnPush = function (id) {
            _this.props.saveSearchTerm(_this.props.searchTerm ? _this.props.searchTerm : '');
            _this.props.onPush(id);
        };
        _this.handleOpenDownload = function (pkg) {
            if (_this.props.asperaEnabled && pkg.packageTransferId) {
                _this.props.onOpenDownload(pkg.packageTransferId);
                new matomo_1.MatomoTracker().trackEvent('Received Packages', 'Open Downloaded Package', pkg.id);
            }
            else {
                react_toastify_1.toast.error('Couldn\'t open the downloaded package');
            }
        };
        _this.handleOpenPreferences = function () {
            _this.props.onOpenPreferences();
        };
        _this.handleOpenTransferManager = function () {
            _this.props.onOpenTransferManager();
        };
        _this.handleSort = function (sortKey) {
            _this.props.onSort(sortKey, _this.props.pageSize, _this.props.searchTerm);
        };
        return _this;
    }
    /* Component Lifecycle Methods - Begin */
    ReceivedPackages.prototype.componentDidMount = function () {
        this.props.onGetReceivedPackages(this.props.pageSize, this.props.searchTerm);
    };
    ReceivedPackages.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.searchTerm !== this.props.searchTerm ||
            prevProps.selectedUsers.length !== this.props.selectedUsers.length) {
            this.props.onUpdateCurrentOffset(0);
            this.props.onGetReceivedPackages(this.props.pageSize, this.props.searchTerm);
        }
    };
    /* Component Methods - End */
    ReceivedPackages.prototype.render = function () {
        var _this = this;
        var _a = this.props, isSearching = _a.isSearching, sortKey = _a.sortKey, sortDirection = _a.sortDirection, hasMorePackages = _a.hasMorePackages;
        var searchingPackagesTitle = react_1.default.createElement("h1", null, "Searching received packages");
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "box received-packages" },
                react_1.default.createElement("div", { className: "table received-packages-table" },
                    react_1.default.createElement("div", { className: "columns header is-mobile" },
                        react_1.default.createElement("div", { className: "column is-1 th is-variable" }),
                        react_1.default.createElement(SortHeader_1.SortHeader, { className: 'is-2 is-resize', sortKey: constants_2.senderNameSortField, text: "Sender", currentSortKey: sortKey, currentSortDirection: sortDirection, onClick: this.handleSort }),
                        react_1.default.createElement(SortHeader_1.SortHeader, { className: 'is-3 is-resize', sortKey: constants_2.titleSortField, text: "Subject", currentSortKey: sortKey, currentSortDirection: sortDirection, onClick: this.handleSort }),
                        react_1.default.createElement(SortHeader_1.SortHeader, { className: 'is-1 is-variable', sortKey: constants_2.sizeSortField, text: "Size", currentSortKey: sortKey, currentSortDirection: sortDirection, onClick: this.handleSort }),
                        react_1.default.createElement(SortHeader_1.SortHeader, { className: 'is-2 is-resize', sortKey: constants_2.creationDateSortField, text: "Received", currentSortKey: sortKey, currentSortDirection: sortDirection, onClick: this.handleSort }),
                        react_1.default.createElement(SortHeader_1.SortHeader, { className: 'is-2 is-variable', sortKey: constants_2.expirationDateSortField, text: "Expires", currentSortKey: sortKey, currentSortDirection: sortDirection, onClick: this.handleSort })),
                    !isSearching && this.props.packages.map(function (p) {
                        return react_1.default.createElement(PackageDetailRow, { key: p.id, pkg: p, asperaEnabled: _this.props.asperaEnabled, asperaInitializing: _this.props.asperaInitializing, maxDownloadSizeInMB: _this.props.downloadSizeLimitInMB, onDownload: function () { return _this.handleDownload(p); }, onDownloadRetry: function () { return _this.handleDownloadRetry(p); }, onDownloadStop: function () { return _this.handleDownloadStop(p); }, onOpenDownload: function () { return _this.handleOpenDownload(p); }, onOpenPreferences: _this.handleOpenPreferences, onOpenTransferManager: _this.handleOpenTransferManager, onPush: function () { return _this.handleOnPush(p.id); } });
                    }),
                    this.props.packages.length === 0 && !isSearching &&
                        react_1.default.createElement("div", { className: "columns header is-mobile" },
                            react_1.default.createElement("div", { className: "column is-12 td" }, this.props.searchTerm && this.props.searchTerm !== '' ?
                                "No received packages found while searching for \"" + this.props.searchTerm + "\"" :
                                react_1.default.createElement("div", null,
                                    "No recently received packages!",
                                    react_1.default.createElement("span", { className: "icon" },
                                        react_1.default.createElement("i", { className: "fas fa-frown" })))))),
                hasMorePackages &&
                    react_1.default.createElement("div", { className: "has-text-centered" },
                        react_1.default.createElement("button", { type: "button", className: "button is-primary", onClick: this.handleLoadMore }, "Load More"))),
            isSearching &&
                react_1.default.createElement(LoadingIndicator_1.LoadingIndicator, { title: searchingPackagesTitle })));
    };
    return ReceivedPackages;
}(react_1.Component));
exports.ReceivedPackages = ReceivedPackages;
var PackageDetailRow = function (props) {
    var asperaEnabled = props.asperaEnabled, maxDownloadSizeInMB = props.maxDownloadSizeInMB, onDownload = props.onDownload, onDownloadRetry = props.onDownloadRetry, onDownloadStop = props.onDownloadStop, onOpenDownload = props.onOpenDownload, onOpenTransferManager = props.onOpenTransferManager, onPush = props.onPush, pkg = props.pkg;
    var pkgExpirationDiff = moment_1.default(pkg.expirationDate).diff(moment_1.default.now(), 'seconds');
    var pkgExpired = pkg.pkgState === models_1.PackageState.DELETED || pkgExpirationDiff < 0;
    var downloadOpenButton = react_1.default.createElement(OpenDownloadButton_1.OpenDownloadButton, { asperaEnabled: asperaEnabled, maxDownloadSizeInMB: asperaEnabled ? undefined : maxDownloadSizeInMB, onDownload: onDownload, onOpenDownload: onOpenDownload, pkg: pkg, pkgExpired: pkgExpired, showDownloadBtn: true });
    var downloadPackageButton = react_1.default.createElement(DownloadButton_1.DownloadButton, { disabled: props.asperaInitializing, maxDownloadSizeInMB: asperaEnabled ? undefined : maxDownloadSizeInMB, onDownload: pkg.packageTransferId && pkg.state ? onDownloadRetry : onDownload, pkg: pkg, pkgExpired: pkgExpired });
    var downloadPauseButton = react_1.default.createElement(PauseButton_1.PauseButton, { disabled: props.asperaInitializing, onDownloadStop: onDownloadStop, showTooltip: false });
    var downloadResumeButton = react_1.default.createElement(RetryButton_1.RetryButton, { disabled: props.asperaInitializing, icon: 'fa-play', onDownload: pkg.packageTransferId ? onDownloadRetry : onDownload, showTooltip: false });
    var progressDetails = react_1.default.createElement(PackageProgressDetails_1.PackageProgressDetails, { transferredBytes: pkg.transferredBytes, totalBytes: pkg.totalBytes });
    var downloadButton;
    if (asperaEnabled) {
        if ((pkg.state === models_1.PackageTransferState.FAILED || pkg.state === models_1.PackageTransferState.STOPPED)) {
            downloadButton =
                react_1.default.createElement(react_1.default.Fragment, null,
                    downloadResumeButton,
                    progressDetails);
        }
        else if (pkg.state === models_1.PackageTransferState.IN_PROGRESS) {
            downloadButton =
                react_1.default.createElement(react_1.default.Fragment, null,
                    downloadPauseButton,
                    progressDetails);
        }
        else {
            var isPackageTransferComplete = pkg.state === models_1.PackageTransferState.COMPLETE;
            var isPackageTransferCompleteRemoved = pkg.state === models_1.PackageTransferState.REMOVED && pkg.totalBytes === pkg.transferredBytes;
            if (isPackageTransferComplete || isPackageTransferCompleteRemoved) {
                downloadButton = downloadOpenButton;
            }
            else {
                downloadButton = downloadPackageButton;
            }
        }
    }
    else {
        if (pkg.state !== models_1.PackageTransferState.IN_PROGRESS) {
            downloadButton = downloadPackageButton;
        }
        else {
            downloadButton = progressDetails;
        }
    }
    var errorMessage = (pkg.errorMsg ?
        ((pkg.errorDesc) ? pkg.errorMsg + " - " + pkg.errorDesc : pkg.errorMsg) :
        '');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_device_detect_1.isMobile &&
            react_1.default.createElement("hr", null),
        react_1.default.createElement("div", { className: "columns is-mobile", onClick: onPush },
            react_1.default.createElement("div", { className: "column is-1 td is-variable", onClick: utils_1.unclickable },
                react_1.default.createElement("div", { className: "has-text-centered" }, downloadButton)),
            react_1.default.createElement("div", { className: "column is-2 td is-resize has-text-weight-bold" },
                pkg.sender.firstName,
                " ",
                pkg.sender.lastName),
            react_1.default.createElement("div", { className: "column is-3 td is-resize subject-title" },
                pkg.encrypted &&
                    react_1.default.createElement("span", { className: "icon" },
                        react_1.default.createElement("i", { className: "fas fa-lock", title: "Password Protected" })),
                pkg.title),
            react_1.default.createElement("div", { className: "column is-1 td is-variable" },
                react_1.default.createElement(PackageFileSize_1.PackageFileSize, { size: pkg.totalBytes })),
            react_1.default.createElement("div", { className: "column is-2 td is-resize" },
                react_1.default.createElement("span", { className: "tooltip received-date", "data-tooltip": moment_1.default(pkg.creationDate).format(constants_1.DATE_TIME_FORMAT) }, moment_1.default(pkg.creationDate).format(constants_1.DATE_FORMAT))),
            react_1.default.createElement("div", { className: "column is-2 td is-variable" },
                react_1.default.createElement(PackageExpiration_1.PackageExpiration, { expirationDate: (pkg.expirationDate === null) ? '' : pkg.expirationDate })),
            pkg.state &&
                react_1.default.createElement("div", { className: "column is-12 td" },
                    react_1.default.createElement("div", { className: classnames_1.default('download-error', 'help', { 'is-danger': pkg.errorMsg }) },
                        pkg.state === models_1.PackageTransferState.FAILED && pkg.errorMsg &&
                            react_1.default.createElement(react_1.default.Fragment, null,
                                errorMessage,
                                ".",
                                react_1.default.createElement(InfoIcon_1.InfoIcon, { tooltipMsg: InfoIcon_1.ASPERA_ACTIVITY_WINDOW_MSG, onClick: function (e) { e.stopPropagation(); onOpenTransferManager(); } })),
                        pkg.state === models_1.PackageTransferState.STOPPED &&
                            react_1.default.createElement(react_1.default.Fragment, null,
                                "This transfer has been stopped.",
                                react_1.default.createElement(InfoIcon_1.InfoIcon, { tooltipMsg: InfoIcon_1.ASPERA_ACTIVITY_WINDOW_MSG, onClick: function (e) { e.stopPropagation(); onOpenTransferManager(); } })),
                        pkg.state === models_1.PackageTransferState.WILLRETRY &&
                            react_1.default.createElement(react_1.default.Fragment, null,
                                "This transfer has failed and will retry approx. 30 seconds.",
                                react_1.default.createElement(InfoIcon_1.InfoIcon, { tooltipMsg: InfoIcon_1.ASPERA_ACTIVITY_WINDOW_MSG, onClick: function (e) { e.stopPropagation(); onOpenTransferManager(); } })),
                        pkg.state === models_1.PackageTransferState.QUEUED &&
                            react_1.default.createElement(react_1.default.Fragment, null,
                                "This transfer has been added to the queue.",
                                react_1.default.createElement(InfoIcon_1.InfoIcon, { tooltipMsg: InfoIcon_1.ASPERA_ACTIVITY_WINDOW_MSG, onClick: function (e) { e.stopPropagation(); onOpenTransferManager(); } }))),
                    react_1.default.createElement(PackageProgressBar_1.PackageProgressBar, { state: pkg.state, transferredBytes: pkg.transferredBytes, totalBytes: pkg.totalBytes })))));
};
var mapStateToProps = function (store) {
    return {
        activeTransfersList: store.transfers.activeTransfers,
        asperaEnabled: selectors_2.isAsperaEnabled(store),
        asperaInitializing: selectors_2.isAsperaInitializing(store),
        hasMorePackages: selectors_1.hasMoreReceivedPackages(store),
        httpGatewayStatus: store.transfers.httpGatewayStatus,
        isSearching: store.receivedPackages.isSearching,
        packages: store.receivedPackages.packages,
        selectedUsers: store.receivedPackages.selectedUsers,
        sortKey: store.receivedPackages.sortKey,
        sortDirection: store.receivedPackages.sortDirection
    };
};
var mapDispatchToProps = {
    onConnectDownload: actions_3.connectDownload,
    onGetReceivedPackages: actions_1.getReceivedPackages,
    onHttpDownload: actions_3.httpDownload,
    onHttpGatewayDownload: actions_3.httpGatewayDownload,
    onLoadMore: actions_1.loadMore,
    onOpenDownload: actions_3.showDirectory,
    onOpenPreferences: actions_3.showPreferences,
    onOpenTransferManager: actions_3.showTransferManager,
    onPush: actions_2.onPushToPkgDetails,
    onResumeConnectTransfer: actions_3.resumeConnectTransfer,
    onRetryHttpUpload: actions_3.retryHttpUpload,
    onSort: actions_1.sort,
    onStopConnectTransfer: actions_3.stopConnectTransfer,
    onUpdateCurrentOffset: actions_1.updateCurrentOffset,
    saveSearchTerm: actions_2.saveSearchTerm
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ReceivedPackages);
